<div class="inline-block bg-white px-6 rounded-lg shadow-md">
  <div class="flex items-center text-center justify-center gap-5">
    <button class="p-5" [disabled]="decrementDisabled || hasReachedLowerBound" (click)="decrement()">
      <svg-icon class="w-10 h-10 block text-primary" src="./assets/evsb/img/minus.svg"></svg-icon>
    </button>

    <input type="number" disabled size="2" [id]="id" [attr.max]="max" [attr.min]="min" [(ngModel)]="value" />

    <button class="p-5" [disabled]="incrementDisabled || hasReachedUpperBound" (click)="increment()">
      <svg-icon class="w-10 h-10 block text-primary" src="./assets/evsb/img/plus.svg"></svg-icon>
    </button>
  </div>
</div>
